// Environment variable configuration with type safety

interface Env {
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  TENANT_API_URL: string;
  ENV: 'development' | 'staging' | 'production';
  IS_DEV: boolean;
  IS_PROD: boolean;
}

function getEnvVar(key: string, required = true): string {
  const value = import.meta.env[key];
  if (required && !value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value ?? '';
}

export const env: Env = {
  SUPABASE_URL: getEnvVar('VITE_SUPABASE_URL'),
  SUPABASE_ANON_KEY: getEnvVar('VITE_SUPABASE_ANON_KEY'),
  TENANT_API_URL: getEnvVar('VITE_TENANT_API_URL'),
  ENV: (getEnvVar('VITE_ENV', false) || 'development') as Env['ENV'],
  get IS_DEV() {
    return this.ENV === 'development';
  },
  get IS_PROD() {
    return this.ENV === 'production';
  },
};
